export default function Spinner() {
	return <span className="components-spinner" />;
}
